import 'idempotent-babel-polyfill';
import alt from '../../alt';
import si from 'si';
import PersonalInfoActions from './PersonalInfoActions';

class PersonalInfoStore {
	constructor() {
		this.state = {
			firstName: '',
			lastName: '',
			homePhoneNumber: '',
			homePhoneNumberType: 'HOME',
			mobilePhoneNumber: '',
			mobilePhoneNumberType: 'MOBILE',
			birthDate: '',
			email: '',
			validEmail: false,
			emailOptOut: false,
			emailExists: false,
			cultureList: [],
			culture: '',
			userName: '',
			usernameExists: false,
			validUsername: false,
			phoneFormats: [],
			originalState: {},
			minAge: 18,
			maxAge: 100,
			BirthYear: '',
			BirthMonth: '',
			BirthDay: ''
		};

		this.bindListeners({
			gotCountriesAndCultures: PersonalInfoActions.GET_COUNTRIES_CULTURES_SUCCESS,
			gotCustomerInformation: PersonalInfoActions.GET_CUSTOMER_INFORMATION_SUCCESS,
			userNameValidation: PersonalInfoActions.USER_NAME_SUCCESS,
			fieldChanged: PersonalInfoActions.CHANGE_FIELD,
			phoneFormatsSuccess: PersonalInfoActions.PHONE_FORMATS_SUCCESS,
			cancelChanges: PersonalInfoActions.CANCEL_CHANGES,
			emailExists: PersonalInfoActions.EMAIL_SUCCESS
		});
	}
	
	phoneFormatsSuccess(formats) {
		this.setState({ phoneFormats: formats });
	}
	gotCountriesAndCultures(diff) {
		this.setState(diff);
	}
	cancelChanges() {
		console.log(this.state);
		this.setState(this.state.originalState);
	}

	gotCustomerInformation(info) {
		this.setState(info);
		if (info.birthDate) {
			try {
				let birthDate = new Date(info.birthDate);
				this.setState({
					BirthYear: birthDate.getFullYear().toString(),
					BirthMonth: (birthDate.getMonth() < 9
							? '0'
							: '') +
						(birthDate.getMonth() + 1).toString(), // getMonth() is zero-based
					BirthDay: birthDate.getDate().toString()
				});
			} catch (e) {
			}
		} else {
			this.setState({
				BirthYear: '',
				BirthMonth: '',
				BirthDay: ''
			});
		}
		this.setState({
			originalState: info
		});
	}

	userNameValidation(hasRecord) {
		this.setState({
			usernameExists: typeof hasRecord === 'boolean' ? !hasRecord : true,
			validUsername: typeof hasRecord === 'boolean' ? hasRecord : false
		});
	}
	fieldChanged(diff) {
		this.setState(diff);
	}
	emailExists(hasRecord) {
		this.setState({
			emailExists: typeof hasRecord === "boolean" ? !hasRecord : true,
			validEmail: typeof hasRecord === "boolean" ? hasRecord : false
		});
	}
}

export default alt.createStore(PersonalInfoStore, 'PersonalInfoStore');



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/PersonalInfo/PersonalInfoStore.js